<div style="height: 100vh">
    <div class="container" [@inAnimation]>
        <div class="messageBox">
            @if (tradingLogo != 'null') {
            <p>
                <img src="https://sings-media.s3.eu-west-2.amazonaws.com/logo/{{ tradingLogo }}" width="155px" style="mix-blend-mode: multiply;">
            </p>
            }

            <h1 class="blackFont">
                <span>{{ customerName }}</span>
            </h1>

            <h2>
                Thank you for your payment of
                <span class="blackFont">{{ paymentAmount | currency: 'GBP' }}</span>
            </h2>

            @if (!fakeEmail) {
            <h2>You will receive a receipt shortly.</h2>
            } @else {
            <h2>The proof of payment will be sent directly to the shop.</h2>
            }

            @if (tradingEmail != 'null' && tradingPhone != 'null') {
            <h2 style="max-width: 700px;">
                If you have any questions, please contact us on
                <span class="blackFont">{{ tradingEmail }}</span> or by phone
                <span class="blackFont">{{ tradingPhone }}</span>.
            </h2>
            } @else if (tradingEmail != 'null') {
            <h2 style="max-width: 700px;">
                If you have any questions, please contact us on
                <span class="blackFont">{{ tradingEmail }}</span>.
            </h2>
            } @else if (tradingPhone != 'null') {
            <h2 style="max-width: 700px;">
                If you have any questions, please contact us by phone
                <span class="blackFont">{{ tradingPhone }}</span>.
            </h2>
            }

            <br>
            <h3>Kind Regards,</h3>
            <h3>{{ tradingName }} Team</h3>

            @if (systemMessage != '') {
            <br><br>
            <h3><u>{{ systemMessage }}</u></h3>
            }
        </div>
    </div>
</div>